import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { useMe } from '@crehana/web';

import GET_LIVES from 'Jsx/CrehanaLive/graphql/GetLives.graphql';
import type {
  GetLives,
  GetLivesVariables,
} from 'Jsx/CrehanaLive/graphql/types/GetLives';
import GET_LIVES_B2B from 'Jsx/CrehanaLive/graphql/GetLivesB2B.graphql';
import type {
  GetLivesB2B,
  GetLivesB2BVariables,
} from 'Jsx/CrehanaLive/graphql/types/GetLivesB2B';
import type { LiveNode } from 'Jsx/CrehanaLive/graphql/types/LiveNode';

type UseCurrentAndNextLivesOptions = { isB2B: boolean };

function useLivesQuery(
  variables: GetLivesVariables,
  options?: UseCurrentAndNextLivesOptions,
) {
  const { me } = useMe();

  const isB2B = !!options?.isB2B;
  const response = useQuery<GetLives, GetLivesVariables>(GET_LIVES, {
    variables,
    skip: isB2B,
  });
  const b2bResponse = useQuery<GetLivesB2B, GetLivesB2BVariables>(
    GET_LIVES_B2B,
    {
      variables: { ...variables, slugOrg: me?.organization?.slug },
      skip: !isB2B,
    },
  );

  const { loading, data, error, refetch, fetchMore } = isB2B
    ? b2bResponse
    : response;

  const { edges, pageInfo } = data?.lives || {};

  const lives: LiveNode[] = useMemo(
    () => (edges?.length ? edges.map(l => l!.node!) : []),
    [edges],
  );

  return { lives, pageInfo, loading, error, refetch, fetchMore };
}

export default useLivesQuery;
